import React from 'react'
import work1 from "../../assets/images/home/work1.png";
import work2 from "../../assets/images/home/work2.png";
import work3 from "../../assets/images/home/work3.png";

export const HowItWork = () => {
  return (
    <div className='howItWorkContainer'>
        <div className='container'>
            <div className='howTitle'>How It works?</div>
            <div className='howSubTitle'>A Simpler Way to Land Your Dream Property</div>
            <div className='howGrid'>
                <div className='howCard'>
                    <div><img src={work1}/></div>
                    <div>Apply & Verify</div>
                    <div>Apply by paying a non-refundable fee and wait for admin to verify your application.</div>

                </div>
                 <div className='howCard'>
                    <div><img src={work2}/></div>
                    <div>Visit the Property</div>
                    <div>Schedule your site visit once verified and inspect the property on your selected date.</div>

                </div>
                 <div className='howCard'>
                    <div><img src={work3}/></div>
                    <div>Submit & Get Shortlisted</div>
                    <div>Submit your initial bid and wait to see if you're shortlisted for offline bidding.</div>

                </div>

            </div>

        </div>

    </div>
  )
}
